import { Component, OnInit } from '@angular/core';
import { CommonContentService } from '@tmhcc-ng-lib/content-service';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';

@Component({
  selector: 'ae-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  public claimsContactInfo: string = "";
  constructor(
    private commonContentService: CommonContentService, 
    private loaderService: LoaderService) {}    

  ngOnInit(): void {
    this.commonContentService.setPageTitle();
    this.loaderService.hide();
    
    if(sessionStorage.getItem('productName') != null){
      if(sessionStorage.getItem('productName') == "General Liability" ||
         (sessionStorage.getItem('productName') == "Excess Liability")){
          this.claimsContactInfo = "Online: <a href ='https://claimsappcasualty.tmhcc.com/' target='blank'>https://claimsappcasualty.tmhcc.com/</a><br>E-mail: <a href='mailto:CasualtyClaims@tmhcc.com'>CasualtyClaims@tmhcc.com</a> <br> Phone:  <a href='tel:+18886370872'>1-888-637-0872</a>";
      }
      else if(sessionStorage.getItem('productName') == "Professional Liability"){
        this.claimsContactInfo = "E-mail Contact: <a href='mailto:Submitclaims@tmhcc.com'>Submitclaims@tmhcc.com</a> <br> Phone: <a href='tel:+18007422210'>800-742-2210</a>";
      }
      else if(sessionStorage.getItem('productName') == "Builders' Risk" ||
              sessionStorage.getItem('productName') == "Contractors' Equipment"){
                this.claimsContactInfo = "E-mail: <a href='mailto:inlandmarineclaims@cultd.com'>inlandmarineclaims@cultd.com</a> <br>or <a href='mailto:jkubant@fidelismarine.com'>jkubant@fidelismarine.com</a> <br> Phone: <a href='tel:+14806199230'>(480) 619-9230</a>";
      }
    }
    else{
      this.claimsContactInfo = "<b>General Liability, Remodeling General Liability and Non-Admitted Excess Liability: </b><br>" +
      "Online: <a href ='https://claimsappcasualty.tmhcc.com/' target='blank'>https://claimsappcasualty.tmhcc.com/</a><br>" +
      "E-mail: <a href='mailto:CasualtyClaims@tmhcc.com'>CasualtyClaims@tmhcc.com</a> <br>" +
      "Phone:  <a href='tel:+18886370872'>1-888-637-0872</a><br><br>" +      
      "<b>Contractors Professional Liability:</b><br>" +
      "E-mail Contact: <a href='mailto:Submitclaims@tmhcc.com'>Submitclaims@tmhcc.com</a><br>" +
      "Phone: <a href='tel:+18007422210'>800-742-2210</a><br><br>" +
      "<b>Builder's Risk and Contractor's Equipment:</b><br>" +
      "E-mail: <a href='mailto:inlandmarineclaims@cultd.com'>inlandmarineclaims@cultd.com</a><br>" +
      "or <a href='mailto:jkubant@fidelismarine.com'>jkubant@fidelismarine.com</a>  <br>" +
      " Phone: <a href='tel:+14806199230'>(480) 619-9230</a>";
    }
    window.scrollTo(0, 0);
  }
}
